const Question = ({ question }) => {
  const text =
    question?.description ||
    question?.questionText ||
    question ||
    "No question available";

  return (
    <div
      className="
        h-full w-full overflow-y-auto p-4
        text-[15px] leading-relaxed
        font-semibold font-sans
        text-[#191F2D] dark:text-gray-100
        whitespace-pre-wrap break-words
        scrollbar-thin scrollbar-thumb-[#C9B8EA] dark:scrollbar-thumb-gray-600
        bg-white dark:bg-gray-900 rounded-md border border-[#F0ECF8]
      "
    >
      {text}
    </div>
  );
};

export default Question;
